import type { MenuItem } from '@/consts/navigation';
import { useDynamicMenu } from '@/features/navigation/hooks/useDynamicMenu';
import { useMenuConfig } from '@/features/navigation/hooks/useMenuConfig';
import { Navigate } from 'react-router';

/** Check if a route exists anywhere in the rendered menu tree. */
const routeExistsInMenu = (items: MenuItem[], route: string): boolean => {
  for (const item of items) {
    if (item.to === route) return true;
    if (item.children && routeExistsInMenu(item.children, route)) return true;
  }
  return false;
};

export const HomeRedirect = () => {
  const { homeRedirect, isReady } = useMenuConfig();
  const { menu } = useDynamicMenu();

  if (!isReady) return null;
  if (!homeRedirect) return null;
  if (menu.length === 0) return null;
  if (!routeExistsInMenu(menu, homeRedirect)) return null;

  return <Navigate to={homeRedirect} replace />;
};
